// extracted by mini-css-extract-plugin
module.exports = {"date":"_7RhFPN"};